<template>
  <div class="mycoupons" v-if="showPage">
    <div class="tabBar fixed">
      <div :class="['fl', { active: isShow }]" @click="switchStatus('take')">
        <p>已领取</p>
      </div>
      <div :class="['fr', { active: !isShow }]" @click="switchStatus('untake')">
        <p>待领取</p>
      </div>
    </div>
    <!--兑换-->
    <div class="redeem">
      <div class="input">
        <input type="text" v-model="redeemCode" placeholder="请输入兑换码" />
      </div>
      <span class="fr" @click="redeemCoupon()">兑换</span>
    </div>
    <!-- 券包购买 -->
    <div class="cpackage-list" v-if="isShow && couponPackageList.length > 0">
      <div class="item" v-for="(item, index) in couponPackageList" v-bind:key="index">
        <div style="display: flex">
          <div class="img">
            <div class="c-tit">{{ item.package_coupon_title }}</div>
            <div class="c-price">
              <span>{{ item.package_unit_price }}</span
              >元x<span>{{ item.package_unit_num }}</span
              >张
            </div>
            <div class="c-desc">{{ item.package_coupon_desc }}</div>
          </div>
          <div style="width: 3.2rem">
            <div class="name">{{ item.package_name }}</div>
            <div>{{ item.package_status === 0 ? item.package_error : item.package_shop_desc }}</div>
            <div class="price">
              ¥<span>{{ item.package_selling_price }}</span>
            </div>
          </div>
        </div>
        <div class="btn-buy" :class="item.package_status === 0 ? 'disabled' : ''" @click="buyCouponPackage(item)">立即购买</div>
      </div>
    </div>
    <div v-show="showTake">
      <ul v-if="couponsList.length > 0">
        <li
          :class="item.coupon_property == 4 ? 'package' : ''"
          v-for="(item, index) in couponsList"
          :key="index"
        >
          <div class="property">
            {{ item.coupon_property_str }}
          </div>
          <div class="flex-row-bc">
            <div class="flex-row-sc">
              <img v-if="item.coupon_image && item.coupon_image.length" :src="item.coupon_image" alt="" style="width: .8rem;margin-right: .1rem;">
              <div>
                <div style="max-width: 4rem;" class="coupon-name-tit ellipses">{{ item.name }}</div>
                <p class="expiry-date" style="margin-top: .1rem">
                  {{ item.finished_at }}
                </p>
              </div>
            </div>
            <div class="flex-colum-se red">
              <div class="coupon-name-pri" v-if="item.coupon_type != 5">
                <span class="money-icon" v-if="item.is_discount == 0">￥</span>
                <span v-if="item.is_discount == 1 && item.amount == 0">全免</span>
                <span v-else>{{ item.amount }}</span>
                <span v-if="item.is_discount == 1 && item.amount != 0">折</span>
              </div>
              <div class="fs-20 red" v-if="item.coupon_type != 5">
                {{item.use_condition}}
              </div>
            </div>
          </div>
          <div class="with-top-line flex-row-bc">
            <div class="flex-row-ss" @click="item.showPackageRule = !item.showPackageRule">
              <div style="max-width: 4rem;" :class="!item.showPackageRule ? 'ellipses' : ''">{{ item.package_limit || item.description}}</div>
              <img v-if="item.package_rule" src="../assets/images/icon_arrow_down@2x.png" alt="" style="width: .2rem;margin:.1rem 0 0 .1rem">
            </div>
            <div class="use-btn" @click="toUseCoupon(item)">去使用</div>
          </div>
          <p
            class="use-rule"
            v-if="item.showPackageRule"
            v-html="item.package_rule"
          ></p>
        </li>
      </ul>
      <div class="no-info" v-else>
        <div class="no-goods">
          <img src="../assets/images/empty-01.png" />
          <p>这里什么都没有</p>
        </div>
      </div>
      <!-- 无效优惠券 -->
      <div class="ac" @click="toDisableCoupon" style="color:#666;padding:.6rem">查看无效优惠券 ></div>
    </div>
    <div v-show="showUntake">
      <div v-show="showContent">
        <ul v-if="untakeCouponsList != ''">
          <li v-for="(item, index) in untakeCouponsList" :key="index">
            <div class="property">{{ item.coupon_property_str }}</div>
            <div class="flex-row-bc">
            <div class="flex-row-sc">
              <img v-if="item.coupon_image && item.coupon_image.length" :src="item.coupon_image" alt="" style="width: .8rem;margin-right: .1rem;">
              <div>
                <div style="max-width: 4rem;" class="coupon-name-tit ellipses">{{ item.coupon_name }}</div>
                <p class="expiry-date" style="margin-top: .1rem">
                  {{ item.coupon_deadline }}
                </p>
              </div>
            </div>
            <div class="flex-colum-se red">
              <div class="coupon-name-pri" v-if="item.coupon_type != 5">
                <span class="money-icon" v-if="item.is_discount == 0">￥</span>
                <span v-if="item.is_discount == 1 && item.amount == 0">全免</span>
                <span v-else>{{ item.amount }}</span>
                <span v-if="item.is_discount == 1 && item.amount != 0">折</span>
              </div>
              <div class="fs-20 red" v-if="item.coupon_type != 5">
                {{item.use_condition}}
              </div>
            </div>
          </div>
          <div class="with-top-line flex-row-bc">
            <div class="flex-row-ss" @click="item.showPackageRule = !item.showPackageRule">
              <div style="max-width: 4rem;" :class="!item.showPackageRule ? 'ellipses' : ''">{{ item.package_limit || item.coupon_description}}</div>
              <img v-if="item.package_rule" src="../assets/images/icon_arrow_down@2x.png" alt="" style="width: .2rem;margin:.1rem 0 0 .1rem">
            </div>
            <div class="use-btn" @click="receiveCoupon(item)">领取</div>
          </div>
          <p
            class="use-rule"
            v-if="item.showPackageRule"
            v-html="item.package_rule"
          ></p>
          </li>
        </ul>
        <div class="no-info" v-else>
          <div class="no-goods">
            <img src="../assets/images/empty-01.png" />
            <p>这里没有可用的优惠券</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { actions } from "../store/actions";
// import { MessageBox,Toast } from 'mint-ui'

export default {
  data() {
    return {
      showPage: false,
      couponsList: [],
      showTake: true,
      untakeCouponsList: [],
      showUntake: false,
      isShow: true,
      showContent: false,
      redeemCode: "",
      couponPackageList: [],
    };
  },
  computed: {
    schoolInfo() {
      return this.$store.state.schoolInfo;
    },
    wxLoginToken() {
      return this.$store.state.wxLoginToken;
    },
    openId() {
      return this.$store.state.openId;
    },
  },
  created() {
    var _this = this;
    // document.title = '我的优惠券'
    _this.getCouponList();
    _this.getOnlineCouponList();
    _this.getCouponPackageList();
  },
  methods: {
    getCouponList: function () {
      var _this = this;
      var params2 = {
        token: _this.wxLoginToken,
        user_id: window.localStorage.getItem("wxUid"),
        school_id: _this.schoolInfo.schoolId,
      };
      var params = {
        params: params2,
      };
      actions.PostCouponList(_this, params, function (data) {
        for (var i = 0; i < data.length; i++) {
          if (data[i].business === 10001 || data[i].business === "10001") {
            let coupon_property = data[i].coupon_property,
              coupon_property_str = "普通优惠";
            switch (coupon_property) {
              case 1:
                coupon_property_str = "普通优惠";
                break;
              case 2:
                coupon_property_str = "会员福利";
                break;
              case 3:
                coupon_property_str = "单单返现";
                break;
              case 4:
                coupon_property_str = `超值券包x${data[i].package_num}张`;
                break;
              case 7:
                coupon_property_str = "配送福利";
                break;
            }
            data[i].showPackageRule = false;
            data[i].coupon_property_str = coupon_property_str;
            if (data[i].package_rule) {
              data[i].package_rule = data[i].package_rule.replace(
                /(\n|\r|\r\n|↵)/g,
                "<br/>"
              );
            }
            _this.couponsList.push(data[i]);
          }
        }
        _this.showPage = true;
      });
    },
    getOnlineCouponList: function () {
      var _this = this;
      var params = {
        token: _this.wxLoginToken,
        user_id: window.localStorage.getItem("wxUid"),
        school_id: _this.schoolInfo.schoolId,
        platform: 2,
      };
      actions.PostOnlineCouponList(_this, params, function (data) {
        for (var i = 0; i < data.length; i++) {
          if (data[i].business === 10001 || data[i].business === "10001") {
            let coupon_property = data[i].coupon_property,
              coupon_property_str = "普通优惠";
            switch (coupon_property) {
              case 1:
                coupon_property_str = "普通优惠";
                break;
              case 2:
                coupon_property_str = "会员福利";
                break;
              case 3:
                coupon_property_str = "单单返现";
                break;
              case 4:
                coupon_property_str = `超值券包x${data[i].package_num}张`;
                break;
              case 7:
                coupon_property_str = "配送福利";
                break;
            }
            data[i].showPackageRule = false;
            data[i].coupon_property_str = coupon_property_str;
            if (data[i].package_rule) {
              data[i].package_rule = data[i].package_rule.replace(
                /(\n|\r|\r\n|↵)/g,
                "<br/>"
              );
            }
            _this.untakeCouponsList.push(data[i]);
          }
        }
        // console.log(_this.untakeCouponsList)
        _this.showContent = true;
      });
    },
    toUseCoupon: function (item) {
      if (item.coupon_property == 4) {
        if (item.package_shop) {
          this.$router.push({
            name: "CouponPackageShopList",
            query: { shops: item.package_shop.join(',') },
          });
        }
      } else {
        if (item.obtain_shop_id) {
          this.$router.push({
            path: `/goodslist?shopCode=${item.obtain_shop_id}`,
          });
        } else {
          this.$router.push({ path: "/index" });
        }
      }
    },
    switchStatus: function (status) {
      var _this = this;
      if (status === "take") {
        _this.showTake = true;
        _this.showUntake = false;
        _this.isShow = true;
      } else if (status === "untake") {
        _this.showUntake = true;
        _this.showTake = false;
        _this.isShow = false;
      }
    },
    receiveCoupon: function (coupon) {
      var _this = this;
      _this.showContent = false;
      if (coupon.is_new == 1) {
        var params = {
          user_id: window.localStorage.getItem("wxUid"),
          coupon_code: coupon.code,
          client_type: 3,
          school_id: _this.schoolInfo.schoolId,
          platform: 2,
        };
        actions.receiveCouponNew(
          _this,
          params,
          function (data) {
            _this.$toast("领取成功");
            _this.couponsList = [];
            _this.untakeCouponsList = [];
            _this.showUntake = false;
            _this.getCouponList();
            _this.getOnlineCouponList();
            _this.showUntake = true;
            _this.showTake = false;
            _this.isShow = false;
          },
          function (response) {
            _this.$messagebox.alert(response.message);
            // 响应错误回调
          }
        );
      } else {
        var params = {
          user_id: window.localStorage.getItem("wxUid"),
          coupon_id: coupon.coupon_id,
          code: coupon.code,
          school_id: _this.schoolInfo.schoolId,
          client_type: 3,
          school_id: _this.schoolInfo.schoolId,
        };
        actions.receiveCouponOld(
          _this,
          params,
          function (data) {
            _this.$toast("领取成功");
            _this.couponsList = [];
            _this.untakeCouponsList = [];
            _this.showUntake = false;
            _this.getCouponList();
            _this.getOnlineCouponList();
            _this.showUntake = true;
            _this.showTake = false;
            _this.isShow = false;
          },
          function (response) {
            _this.$messagebox.alert(response.message);
          }
        );
      }
    },
    redeemCoupon: function () {
      if (!this.redeemCode || this.redeemCode.length == 0) {
        this.$toast("请输入兑换码");
        return;
      }
      var _this = this;
      var params = {
        redeem_code: this.redeemCode,
        login_token: window.localStorage.getItem("wxLoginToken"),
      };
      actions.redeemCoupon(
        _this,
        params,
        function (response) {
          _this.$toast(response);
          _this.getCouponList();
        },
        function (response) {
          _this.$toast(response.data.message);
          // 响应错误回调
        }
      );
    },
    // 券包
    getCouponPackageList() {
      let _this = this;
      let params = {
        school_id: _this.schoolInfo.schoolId,
        source: 3
      };
      actions.postPackageList(_this, params, (data) => {
        if (data && data.length > 0) {
          _this.couponPackageList = data;
          // 曝光埋点
          let logDetails = [{
            uid: _this.$store.state.wxUid,
            code: 'asa_coupon_bag',
            refId: data[0].package_id,
            createTime: new Date().getTime(),
            firstValue: _this.$store.state.schoolInfo.schoolId
          }]
          _this.addLog(logDetails);
        }
      },() => {

      });
    },
    // 购买券包
    buyCouponPackage(item) {
      if(item.package_status === 0){
        return;
      }
      this.$router.push({name: 'CouponPackage', query: {id: item.package_id}})
      // 点击埋点
      let logDetails = [{
        uid: this.$store.state.wxUid,
        code: 'click_coupon_bag',
        createTime: new Date().getTime(),
        refId: item.package_id,
        firstValue: this.$store.state.schoolInfo.schoolId
      }]
      this.addLog(logDetails);
    },
    // 统计埋点
    addLog(list) {
      var _this = this;
      var params = {
        logDetails: list,
        source: 3
      }
      actions.postLogAdd(_this, params, function (data) {
        // console.log('记录成功');
      }, function (data) {

      })
    },
    toDisableCoupon() {
      this.$router.push({name: 'myDisableCoupons' })
    }
  },
};
</script>
<style scoped>
.redeem {
  margin-top: 0.2rem;
  padding: 0.22rem 0.32rem;
  height: 0.88rem;
  background-color: #fff;
}

.redeem span {
  font-size: 0.32rem;
  color: #ffdf00;
}

.redeem .input input {
  float: left;
  width: 60%;
}

.redeem .input input::placeholder {
  color: #999;
}

.redeem input {
  font-size: 0.28rem;
}
.cpackage-list {
  margin: 0.24rem 0.24rem 0 0.24rem;
}
.no-goods {
  position: inherit;
  margin: 2rem auto;
}
</style>




// WEBPACK FOOTER //
// MyCoupons.vue?55823f32